export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.20-1602.31",
  commitId: "5f7e1c2deac68951236fe4f99279227027900e89",
  commitTime: "2026-05-20T16:02:31.000Z",
});
